var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPromo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "promo",
    d: "M6.95,26.559v6.51l6.51-1.608,4.9,4.9,4.9-4.9,6.51,1.608v-6.51l6.587-1.685-3.294-6.51,3.294-6.51-6.587-1.685V3.657l-6.51,1.608-4.9-4.9-4.9,4.9L6.95,3.657v6.51L.363,11.853l3.294,6.51L.363,24.873Zm-.383-9.651L5.112,13.92l2.6-.613a2.846,2.846,0,0,0,1.8-1.11,3.316,3.316,0,0,0,.65-2.029V7.87l2.452.689h.842a3.154,3.154,0,0,0,2.3-1l2.6-2.6,2.6,2.6a3.156,3.156,0,0,0,2.3,1,2.251,2.251,0,0,0,.842-.153l2.452-.536v2.3A3.322,3.322,0,0,0,27.21,12.2a2.851,2.851,0,0,0,1.8,1.111l2.6.613L30.16,16.909a2.956,2.956,0,0,0,0,2.911l1.455,2.988-2.6.613a2.846,2.846,0,0,0-1.8,1.11,3.32,3.32,0,0,0-.651,2.028v2.3l-2.452-.689h-.842a3.154,3.154,0,0,0-2.3,1l-2.6,2.6-2.6-2.6a3.156,3.156,0,0,0-2.3-1,2.251,2.251,0,0,0-.842.153l-2.452.536v-2.3a3.322,3.322,0,0,0-.651-2.029,2.846,2.846,0,0,0-1.8-1.11l-2.6-.613,1.455-2.988a2.956,2.956,0,0,0,0-2.911Zm10.187,7.047,7.66-7.737a1.5,1.5,0,0,0,0-2.3,1.574,1.574,0,0,0-2.3,0l-5.362,5.438L14.61,17.214a1.625,1.625,0,0,0-2.3,2.3Z",
    transform: "translate(-0.363 -0.363)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromo);
export default __webpack_public_path__ + "static/media/promo.2cfb49cc04e1e1f5c40fda52186e62d8.svg";
export { ForwardRef as ReactComponent };